import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-delete-product-master-group',
  templateUrl: './delete-product-master-group.component.html',
  styleUrls: ['./delete-product-master-group.component.css']
})
export class DeleteProductMasterGroupComponent implements OnInit {

  productGroupList:any = []
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  singleParam:any = []
  productGroupId: any;

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.getAllProductMasterGroup();
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllProductMasterGroup();
  }

  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllProductMasterGroup();
  }

  getAllProductMasterGroup(){
    this.generic_service.getAllProductMasterGroup().subscribe(
      (res:any)=> {
        console.log(res)
        this.productGroupList = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  deleteProductMasterGroup(){
    this.generic_service.deleteProductMasterGroup(this.productGroupId).subscribe(
      (res:any)=>{
        this.toastr.success("Successfully Deleted");
        this.getAllProductMasterGroup();
        this.cancelModel();
      },err=>{
        this.toastr.error(err.errors[0].description)
      }
    )
  }

  deleteProductGroup(id:any){
    this.productGroupId = id
  }


}
